// this mixin is used to remove the field _typename

export default {
  methods: {
    mixPrepareTranslations (payload) {
      if (!Object.prototype.hasOwnProperty.call(payload, 'translations')) return payload
      delete payload.translations.__typename
      Object.keys(payload.translations).forEach(field => {
        if (payload?.translations[field]) {
          if (payload.translations[field].__typename) {
            delete payload.translations[field].__typename
          }
        }
      })
      return payload
    }
  }
}
